import { IconButton } from '@festina-life/ui/actions'
import { RawTextInput } from '@festina-life/ui/forms'
import { Icon } from '@festina-life/ui/structure'

import type { ApprovalStatus } from '../../../configurationItemsTree/types'
import { BranchChangesetApprovalFilter } from './BranchChangesetApprovalFilter'
import { ToggleBranchChangesetsState } from './ToggleBranchChangesetsState'
import type { BranchConciseChangesetListVariant } from './types'

type Props = {
  query: string
  onQueryChanged: (query: string) => void
  onExpandAll: () => void
  onCollapseAll: () => void
  statusFilter: Record<ApprovalStatus, boolean>
  onStatusFilterChanged: (statusFilter: Record<ApprovalStatus, boolean>) => void
  variant: BranchConciseChangesetListVariant
}

export const BranchChangesetListOptions = ({
  query,
  onQueryChanged,
  onExpandAll,
  onCollapseAll,
  statusFilter,
  onStatusFilterChanged,
  variant,
}: Props) => (
  <div className="flex gap-x-2 items-center mb-2">
    <ToggleBranchChangesetsState />
    <RawTextInput
      value={query}
      onChange={(event) => onQueryChanged(event.target.value)}
      addOnProps={{ element: <Icon name="MagnifyingGlass" /> }}
    />
    {variant !== 'review' && (
      <BranchChangesetApprovalFilter
        approvalStatus={statusFilter}
        onApprovalStatusChanged={onStatusFilterChanged}
      />
    )}
    <div className="flex flex-row gap-x-1">
      <IconButton onClick={onExpandAll} iconName="ChevronUpDown" />
      <IconButton onClick={onCollapseAll} iconName="ChevronDownUp" />
    </div>
  </div>
)
